import { render } from "./GuiLanguage.vue?vue&type=template&id=6058c99a"
import script from "./GuiLanguage.vue?vue&type=script&lang=js"
export * from "./GuiLanguage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/ThesauRex/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__